module.exports = __webpack_public_path__ + "static/profile-pic-ed9c518c62fa368b844ec5fb3383bad4.png";